// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"66acdc62","223":"d9de2ba6","819":"2f0ea952","938":"c6b7f802","949":"50d05418","989":"901972a0"}[chunkId] + ".chunk.css";
};